export const times = x => f => {
  if (x > 0) {
    f()
    times(x - 1)(f)
  }
}

export const isElementInViewport = el => {
  const rect = el.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export const isAnyPartOfElementInViewport = el => {
  const rect = el.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight
  const windowWidth = window.innerWidth || document.documentElement.clientWidth
  const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0
  const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0
  return vertInView && horInView
}

export const groupArrayBy = (source, key) => {
  return source.reduce((groups, item) => {
    const val = item[key]
    groups[val] = groups[val] || []
    groups[val].push(item)
    return groups
  }, {})
}

export const assertExists = (varName, scope, message = null) => {
  /* istanbul ignore else */
  if (scope[varName] === undefined) {
    throw message || `Variable ${varName} doesn't exist.`
  }
}

const hasOwnProperty = Object.prototype.hasOwnProperty
export const isEmpty = obj => {
  if (typeof obj !== 'object') return true
  if (obj == null) return true

  for (let key in obj) {
    /* istanbul ignore else */
    if (hasOwnProperty.call(obj, key)) return false
  }

  return true
}

let supportWebp
export const supportFormatWebp = () => {
  if (supportWebp !== undefined) return supportWebp

  const elem = document.createElement('canvas')

  if (elem.getContext && elem.getContext('2d')) {
    // was able or not to get WebP representation
    supportWebp = elem.toDataURL('image/webp').indexOf('data:image/webp') == 0
  } else {
    // very old browser like IE 8, canvas not supported
    supportWebp = false
  }
  return supportWebp
}

export const loadJavascript = url => {
  if (window['_CI_loadedScripts'] === undefined) {
    window._CI_loadedScripts = {}
  }
  if (window._CI_loadedScripts[url]) {
    return
  }
  window._CI_loadedScripts[url] = true
  const scriptTag = document.createElement('script')
  scriptTag.src = url
  document.body.appendChild(scriptTag)
}
